export const removeFileNameSpecialCharacters = (fileName: string) =>
  fileName.replace(/[^a-zA-Z0-9_. ()-]/g, '');

export const removeFileExtension = (fileName: string) => {
  const lastDotIndex = fileName.lastIndexOf('.');
  return lastDotIndex !== -1 ? fileName.slice(0, lastDotIndex) : fileName;
};

export const appendExtensionToFilename = (filename: string, extension: string) =>
  `${filename}.${extension.toLowerCase()}`;

export const appendExtensionToFilenameFromMimeType = (filename: string, mimeType?: string) =>
  mimeType ? `${filename}.${mimeType.split('/')[1].toLowerCase()}` : filename;

export const downloadUrlAsFile = (url: string, fileName: string): void => {
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
